export default "__VITE_ASSET__nWP2mshA__"